//* Setting up Medallia with user token and player id

const medalliaSetUserInfo = (user) => {
    const cookieMedallia = document.cookie.split(';').filter((i) => i.includes('incap'));
    const combinedMedalliaData = [cookieMedallia, user?.player?.player_id];
    window.medalliaUserData = combinedMedalliaData;

    //? For debug: console.log('🔵 Medallia user info:', combinedMedalliaData);
};

export default medalliaSetUserInfo;
